module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-818-retro.4743461b.jpg";